import React from 'react'
import { NextPage } from 'next'
import { PageProps } from 'types/page'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import Insurance from 'experiences/products/directories/InsuranceDirectory'

const InsurancePage: NextPage<PageProps> = ({ metaTags }): JSX.Element => (
	<StandardLayout metaTags={metaTags}>
		<Insurance />
	</StandardLayout>
)

export const getServerSideProps = defaultSSRProps

export default InsurancePage
